// import { Box, Image } from "@mantine/core";
// import { Carousel } from "@mantine/carousel";

import { Zoom } from "react-reveal";

import { Slideshow } from "../components";

const images = [
	{
		id: 4,
		imageUrl: "fyp-images/Day5-Birthday/img1.jpg",
		category: "Birthday",
	},
	{
		id: 2,
		imageUrl: "fyp-images/Day2-Denin/img1.jpg",
		caption: "Denim Day",
	},
	{
		id: 1,
		imageUrl: "fyp-images/Day1-Sport/img5.jpg",
		caption: "Jersey Day",
	},
	{
		id: 3,
		imageUrl: "fyp-images/Day3-Ankara/img2.jpg",
		caption: "Ankara Day",
	},
	{
		id: 5,
		imageUrl: "fyp-images/Day5-White/img1.jpg",
		category: "Sign Out Day",
	},
	{
		id: 6,
		imageUrl: "fyp-images/Day4-Corporate/img4.jpg",
		category: "Corporate Day",
	},
];

const Header = () => {
	return (
		<>
			<Zoom>
				{/* <Box style={{ maxHeight: "100vh", display: "flex" }}>
				<Carousel
					mx="auto"
					height="100%"
					inViewThreshold="0.2"
					withIndicators
					loop
				>
					{images.map((image) => (
						<Carousel.Slide key={image.id}>
							<Image src={image.imageUrl} />
						</Carousel.Slide>
					))}
				</Carousel>
			</Box> */}
				<Slideshow slides={images} />;
			</Zoom>
		</>
	);
};

export default Header;
